{
  "AllContentItem": [
    "Channel",
    "LiveStreamEvent",
    "Project"
  ],
  "AnyRecord": [
    "Account",
    "AccountHook",
    "ArchivedItemEvent",
    "Audio",
    "Avatar",
    "Channel",
    "ChannelEpisodeEvent",
    "ChannelEvent",
    "CommentEvent",
    "Contact",
    "ContactEvent",
    "Document",
    "EmbedStatsEvent",
    "Image",
    "LiveSharedVideo",
    "LiveSimulcastTarget",
    "LiveStream",
    "LiveStreamEmail",
    "LiveStreamEvent",
    "LiveStreamEventEvent",
    "Logo",
    "MediaDownload",
    "MediaEvent",
    "MentionedInTeamCommentEvent",
    "MessageEvent",
    "MicrosoftOfficeDocument",
    "PdfDocument",
    "Project",
    "ProjectEvent",
    "RecordingSessionEvent",
    "RepliedToTeamCommentEvent",
    "SessionEvent",
    "SharingEvent",
    "SocialMediaPostEvent",
    "SubscriptionChangeEvent",
    "Swf",
    "TeamCommentEvent",
    "TrialEvent",
    "UnknownMedia",
    "UserEvent",
    "UserGeneratedAccessToken",
    "UserSessionStatsEvent",
    "Video"
  ],
  "AsyncJob": [
    "ExternalMigrationRequest",
    "PodcastImportRequest",
    "ReplaceMediaRequest"
  ],
  "AudienceContainer": [
    "Channel"
  ],
  "AuthorizationStatus": [
    "AuthorizationStatusAllowed",
    "AuthorizationStatusUnauthorizedWithRedirect"
  ],
  "Collaborative": [
    "ChannelRole",
    "LiveStreamEventRole",
    "Sharing"
  ],
  "Container": [
    "Channel",
    "Project"
  ],
  "EditBackground": [
    "BrandPopBackground",
    "ColorBackground",
    "LinearGradientBackground",
    "RadialGradientBackground",
    "UrlBackground",
    "WavesBackground",
    "WhimsicalBackground"
  ],
  "EditBackgroundEffectible": [
    "LinearGradientBackground",
    "RadialGradientBackground",
    "WavesBackground"
  ],
  "EditBackgroundGradient": [
    "LinearGradientBackground",
    "RadialGradientBackground"
  ],
  "EditImportAsset": [
    "Audio",
    "Video"
  ],
  "EditSessionTransition": [
    "EditSessionNoneTransition",
    "EditSessionRealTransition"
  ],
  "EditTiming": [
    "EditLayoutTiming",
    "EditVisibilityTiming",
    "EditZoomSequenceTiming"
  ],
  "Event": [
    "ArchivedItemEvent",
    "ChannelEpisodeEvent",
    "ChannelEvent",
    "CommentEvent",
    "ContactEvent",
    "EmbedStatsEvent",
    "LiveStreamEventEvent",
    "MediaEvent",
    "MentionedInTeamCommentEvent",
    "MessageEvent",
    "ProjectEvent",
    "RecordingSessionEvent",
    "RepliedToTeamCommentEvent",
    "SessionEvent",
    "SharingEvent",
    "SocialMediaPostEvent",
    "SubscriptionChangeEvent",
    "TeamCommentEvent",
    "TrialEvent",
    "UserEvent",
    "UserSessionStatsEvent"
  ],
  "Fields": [
    "EditCaptionsConfig",
    "EditRescript",
    "EditRescriptChunk",
    "EditSession",
    "EditSessionClip",
    "EditSessionClipInput",
    "EditSessionNoneTransition",
    "EditSessionRealTransition",
    "EditSubjectCoordinateSubjectCoordinate"
  ],
  "Identifiable": [
    "EditCaptionsConfig",
    "EditSession",
    "EditSessionClip",
    "EditSessionClipInput",
    "EditSessionNoneTransition",
    "EditSessionRealTransition"
  ],
  "Integration": [
    "FacebookAdsIntegration",
    "GenericIntegration",
    "HubspotIntegration",
    "LinkedinLiveIntegration",
    "MarketoIntegration",
    "YoutubeIntegration"
  ],
  "KeyMomentDetectableSubject": [
    "Face",
    "Person"
  ],
  "LatestActivityEvent": [
    "ArchivedItemEvent",
    "ChannelEpisodeEvent",
    "ChannelEvent",
    "ContactEvent",
    "LiveStreamEventEvent",
    "MediaEvent",
    "ProjectEvent",
    "SubscriptionChangeEvent",
    "TrialEvent"
  ],
  "Media": [
    "Audio",
    "Avatar",
    "Document",
    "Image",
    "LiveSharedVideo",
    "LiveStream",
    "Logo",
    "MicrosoftOfficeDocument",
    "PdfDocument",
    "Swf",
    "UnknownMedia",
    "Video"
  ],
  "NextBestActionResource": [
    "AbTest",
    "Audio",
    "Channel",
    "ChannelEpisode",
    "Document",
    "EditSession",
    "Image",
    "LiveStream",
    "LiveStreamEvent",
    "Logo",
    "MicrosoftOfficeDocument",
    "PdfDocument",
    "Project",
    "Swf",
    "TeamComment",
    "UnknownMedia",
    "Video"
  ],
  "Product": [
    "AnnualDiscountProduct",
    "BandwidthOptionProduct",
    "ChannelLimitProduct",
    "DiscountProduct",
    "DubbingOptionProduct",
    "EncodingOptionProduct",
    "IncludedMediaProduct",
    "IncludedUserProduct",
    "MediaLimitProduct",
    "MediaOptionProduct",
    "Plan",
    "SpeedyEncodingOptionProduct",
    "StorageOptionProduct",
    "TextTranslationOptionProduct",
    "TranscriptionOptionProduct",
    "UnknownProduct",
    "UserLimitProduct",
    "WorkspaceOptionProduct"
  ],
  "RestrictedMedia": [
    "ChannelEpisodeMedia",
    "LiveEventMedia",
    "ReviewLinkMedia"
  ],
  "ShareableResource": [
    "Channel",
    "LiveStreamEvent",
    "Project"
  ],
  "TimelineElement": [
    "EditSessionClip",
    "EditSessionNoneTransition",
    "EditSessionRealTransition"
  ],
  "UserGeneratedToken": [
    "UserGeneratedAccessToken"
  ],
  "VideoContainer": [
    "Channel",
    "Project"
  ]
}